<div class="lumi-switch switch">
    <label>
        <input (change)="onChange()"
               [checked]="initialValue"
               [disabled]="disabled"
               type="checkbox">
        <span class="lever"></span>
    </label>
</div>
